import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import type { Role } from "../api/types";

type Props = {
  children: React.ReactNode;
  roles?: Role[];
};

function ProtectedRoute({ children, roles }: Props) {
  const { user, token } = useAuth();
  const isAuthed = !!user && !!token;
  const allowed = roles ? roles.includes(user?.role as Role) : true;

  if (!isAuthed) return <Navigate to="/login" replace />;
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default ProtectedRoute;
